module.exports = "../images/icons/pdf.svg";